import React, { useMemo } from 'react';
import { InvoiceSummary } from './components/InvoiceSummary';
import { InvoicePreview } from './components/InvoicePreview';
import { InvoicePagePaidDateAndMethod } from './components/InvoicePagePaidDateAndMethod';
import { calculateGrossAmount, isInvoiceStatusPaid } from '../../utils';

export interface IInvoiceSummary {
  invoiceNumber: number;
  recipient: string;
  amount: number;
  discountType: string;
  discount: number;
  salesTax: number;
  dueDate: string;
  status: string;
  paidTime?: string;
  paymentMethod?: string;
  paymentUrl?: string;
  externalId?: string;
}

interface IProps {
  selectedInvoice: IInvoiceSummary;
}

export const InvoicePage = ({ selectedInvoice }: IProps) => {
  const {
    invoiceNumber,
    recipient,
    amount,
    discountType,
    discount,
    salesTax,
    dueDate,
    status,
    paidTime,
    paymentMethod,
    externalId,
  } = selectedInvoice;
  const isStatusPaid = isInvoiceStatusPaid(status);
  const grossAmount = useMemo(
    () => calculateGrossAmount(amount, discountType, discount, salesTax),
    [amount, discountType, discount, salesTax],
  );
  return (
    <div className='block h-full bg-bw01'>
      <InvoiceSummary
        invoiceNumber={invoiceNumber}
        recipient={recipient}
        grossAmount={grossAmount}
        dueDate={dueDate}
        status={status}
        paidTime={paidTime}
      />
      {isStatusPaid && paidTime && paymentMethod && (
        <InvoicePagePaidDateAndMethod paymentDate={paidTime} paymentMethod={paymentMethod} />
      )}
      <InvoicePreview externalId={externalId} />
    </div>
  );
};
